import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../images/logo.png";
import Cookies from "js-cookie";

export default function Header() {
  const userRole = Cookies.get("user_role");

  // React Router hook to track current path
  const location = useLocation();
  const currentPath = location.pathname;

  // All navigation items
  const navItems = [
    { name: "Home", link: "/" },
    { name: "Start Challenge", link: "/start" },
    { name: "Events", link: "https://nlsausa.com/events", external: true },
    { name: "Athlete Dashboard", link: "/dashboard" },
    { name: "My Certificates", link: "/dashboard#mycertificates" },
    { name: "How It Works", link: "/howitworks"},
    { name: "Support", link: "/support" },
    { name: "NLSA USA Main Website", link: "https://nlsausa.com", external: true },
  ];

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm py-2">
      <div className="container-fluid">

        {/* Logo */}
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img src={logo} alt="Logo" height="60" className="d-inline-block me-2" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navMenu"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navMenu">

          {/* Navigation */}
          <ul className="navbar-nav mx-auto">

            {navItems.map((item, index) => (
              <li className="nav-item" key={index}>

                {item.external ? (
                  // External links (open new tab)
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noreferrer"
                    className="nav-link navigation px-3 py-2 fw-semibold"
                    style={{ fontSize: "15px" }}
                  >
                    {item.name}
                  </a>
                ) : (
                  // Internal React Router links
                  <Link
                    to={item.link}
                    className={`nav-link navigation px-3 py-2 fw-semibold ${
                      currentPath === item.link ? "active-nav" : ""
                    }`}
                    style={{ fontSize: "15px" }}
                  >
                    {item.name}
                  </Link>
                )}

              </li>
            ))}

          </ul>

          {/* Right Side Buttons */}
          <div className="d-flex">
            {userRole === "User" ? (
              <Link to="/dashboard">
                <button className="btn btn-outline-primary m-1">My Account</button>
              </Link>
            ) : (
              <Link to="/login">
                <button className="btn btn-primary m-1">Login</button>
              </Link>
            )}
            <Link to="/signup">
                <button className="btn btn-dark m-1">Signup</button>
            </Link>
          </div>
        </div>
      </div>

      {/* Custom Styles */}
      <style>{`
        .active-nav {
          background: #000 !important;
          color: white !important;
          border-radius: 6px;
          font-weight: 700;
        }

        .navigation:hover {
          background: #000;
          color: #fff !important;
          border-radius: 6px;
        }

        .navigation {
          margin: 5px;
          transition: 0.3s;
        }
      `}</style>
    </nav>
  );
}
